import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { BaseIconProps } from './types';
type DefaultUserAvatarProps = BaseIconProps;

/**
 * Default user avatar - orange circle with person silhouette.
 * Used when a user doesn't have a custom avatar.
 */
const DefaultUserAvatar: React.FC<DefaultUserAvatarProps> = t0 => {
  const $ = _c(9);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M128 0C57.3 0 0 57.3 0 128s57.3 128 128 128V0z" fill="#FF9500" />;
    t3 = <Path d="M128 0v256c70.7 0 128-57.3 128-128S198.7 0 128 0z" fill="#FF7B00" />;
    t4 = <Path d="M128 56c-22.1 0-40 17.9-40 40s17.9 40 40 40V56z" fill="#FFD9A8" />;
    t5 = <Path d="M128 56v80c22.1 0 40-17.9 40-40s-17.9-40-40-40z" fill="#FFCA80" />;
    t6 = <Path d="M128 148c-44.2 0-80 28.7-80 64v44h80V148z" fill="#6366F1" />;
    t7 = <Path d="M128 148v108h80v-44c0-35.3-35.8-64-80-64z" fill="#4F46E5" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== iconHeight || $[7] !== iconWidth) {
    t8 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 256 256" fill="none">{t2}{t3}{t4}{t5}{t6}{t7}</Icon>;
    $[6] = iconHeight;
    $[7] = iconWidth;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
export default DefaultUserAvatar;